import { render, staticRenderFns } from "./Findwords.vue?vue&type=template&id=f201c74e&"
import script from "./Findwords.vue?vue&type=script&lang=js&"
export * from "./Findwords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports